import script from "./chat_gpt.vue?vue&type=script&setup=true&lang=js"
export * from "./chat_gpt.vue?vue&type=script&setup=true&lang=js"

import "./chat_gpt.vue?vue&type=style&index=0&id=a3458350&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3458350"]])

export default __exports__